import React from 'react';
import clsx from 'clsx';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, InputAdornment, TextField, Typography } from '@material-ui/core';

import ServiceTitle from './ServiceTitle';
import { ButtonClearInput } from '../../button';
import { AddressSearchDialog } from '../../address';
import { REQUESTER_FIELDS, useRequesterForm } from './requesterShared';

// 의뢰자 정보(데스크톱) — 상호 · 부서명 · 담당자명 · 연락처 / 주소 · 상세주소. 다른 serviceBox 와 같은 카드 틀
const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20,
    padding: '60px 80px 50px 80px',
    '& .MuiInputBase-root': {
      boxShadow: 'none',
      marginBottom: 16,
      width: '100%',
      padding: '0 16px',
      borderRadius: 8,
      border: 'solid 1px #e4e4e9',
      backgroundColor: '#ffffff',
      '& input': {
        height: 50,
        '&::-webkit-input-placeholder': { color: '#cacacf' },
      },
      '& .MuiOutlinedInput-input': { padding: 0 },
    },
    '& .Mui-disabled': { borderColor: 'transparent !important' },
    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px !important' },
  },
  fields: {
    width: '100%',
    marginTop: 30,
  },
  label: {
    marginTop: 40,
  },
  cell: {
    paddingRight: 16,
    '&:last-child': { paddingRight: 0 },
  },
  addrCell: {
    paddingRight: 16,
  },
  addressField: {
    cursor: 'pointer',
    '& input': { cursor: 'pointer' },
  },
}));

function RequesterInfo({ cmStore, loginStore }) {
  const cs = useStyles();
  const { requester, handleChange, addrOpen, openAddress, closeAddress, selectAddress } = useRequesterForm(cmStore, loginStore);

  return (
    <Grid className={clsx('serviceBox', cs.root)} container direction="column" justify="flex-start" alignItems="flex-start">
      <AddressSearchDialog open={addrOpen} type="requester" handleClose={closeAddress} onSelect={selectAddress} />
      <ServiceTitle
        isBtn
        title="출발지와 도착지를 선택해주세요."
        subTitle="로그인하시면 자주 쓰는 경로와 최근 이용 경로 조회가 가능합니다."
      />
      <Typography className={cs.label} variant="subtitle2" color="textPrimary" gutterBottom><b>의뢰자 정보</b></Typography>
      <Grid className={cs.fields} container direction="row" justify="flex-start" alignItems="flex-start" style={{ marginTop: 0 }}>
        {REQUESTER_FIELDS.map((f) => (
          <Grid key={f.name} item xs={3} className={cs.cell}>
            <TextField
              fullWidth
              variant="outlined"
              name={f.name}
              placeholder={f.placeholder}
              value={requester[f.name]}
              onChange={handleChange}
              inputProps={{ autoComplete: f.autoComplete, inputMode: f.inputMode }}
            />
          </Grid>
        ))}
      </Grid>
      <Grid className={cs.fields} container direction="row" justify="flex-start" alignItems="flex-start" style={{ marginTop: 0 }}>
        <Grid item xs={6} className={cs.addrCell}>
          <TextField
            fullWidth
            disabled
            variant="outlined"
            className={cs.addressField}
            placeholder="주소"
            value={requester.addr}
            onClick={openAddress}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end"><ButtonClearInput /></InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            name="addrDtl"
            placeholder="상세주소"
            value={requester.addrDtl}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default inject('cmStore', 'loginStore')(observer(RequesterInfo));
